module.exports = __webpack_public_path__ + "img/visual-b-lg.3f901f2c.png";